// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAwardCustomListBody = {
  poolId: string;
};

export type typeAwardCustomListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    medals: {
      awardTypeId: string;
      name: string;
      color: string;
      status: "active" | "archived";
      grantCount: number;
      memberCount: number;
    }[];
    trophies: {
      awardTypeId: string;
      name: string;
      color: string;
      status: "active" | "archived";
      grantCount: number;
      memberCount: number;
    }[];
  };
};

export type typeAwardCustomListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAwardCustomListBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAwardCustomList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAwardCustomListBody);
  }

  return async function postAwardCustomList(
    payload: typeAwardCustomListBody,
  ): Promise<typeAwardCustomListOutput200 | typeAwardCustomListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAwardCustomList" failed before calling the network. #0371e075c681`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#0371e075c681" },
        },
        data: null,
      } as typeAwardCustomListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/award/custom-list`,
      httpMethod: "POST",
      options,
    })) as typeAwardCustomListOutput200 | typeAwardCustomListOutput400;
  };
}
